import { useAuth } from "@/hooks/useAuth";
import { LoadingOverlay } from "@/components/LoadingOverlay";

export function AuthGate({ children }: { children: React.ReactNode }) {
  const { isLoading, loadingMessage, user } = useAuth();

  // Only show loading overlay during initial auth check when there's no user yet.
  // If user exists (from localStorage), show content immediately while
  // background session validation happens.
  if (isLoading && !user) {
    return <LoadingOverlay message={loadingMessage || "Loading..."} />;
  }

  return <>{children}</>;
}
